import Index from '../../pages/travel/hlw/index';

const base = 'hlw';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Index
  }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/travel/hlw.js